module.exports = __webpack_public_path__ + "static/assets/9bc463bdb4766a41cc125a126202b1f5.png";